import React from 'react';
import onClickOutside from 'react-onclickoutside';

class RetentionInfo extends React.Component {
  onFaceboxClick = (e) => {
    e.preventDefault();
    $.facebox({ div: e.target.getAttribute('href') });
  }

  // specifically named method for onClickOutside
  handleClickOutside() {
    this.props.toggleRetentionInfo();
  }

  render() {
    return (
      <div className="info-bubble mod-retention-info">
        <div className="info-bubble-content">
          <p>
            Everyone gets <a href="#archive" onClick={this.onFaceboxClick}>1 year archive</a>, optional pay-as-you-go&nbsp;
            <a href="#additional-usage" onClick={this.onFaceboxClick}>additional usage</a>, and unlimited &nbsp;
            <a href="#filtering" onClick={this.onFaceboxClick}>noise filtering</a>. Just choose the searchable duration that's right for you.
          </p>
        </div>
      </div>
    );
  }
}

export default onClickOutside(RetentionInfo);